import { X } from 'phosphor-react';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearAllFilters,
  clearFilterGroup,
} from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const ActiveFilterBar = () => {
  const facetedFiltersState = useSelector(
    (state) => state.facetedSearch.facetFilters
  );
  const dispatch = useDispatch();
  return (
    <div className="active-filter-bar">
      {facetedFiltersState.map((filterGroup, idx) => (
        <ActiveFilterChip
          filterGroup={filterGroup}
          key={filterGroup.id + idx}
        />
      ))}
      {facetedFiltersState.some((e) => e.selectedOptions?.length > 0) && (
        <span
          className="[ active-filter-item--clear-all ] [ text-medium lh-2 color-grey-700 text-underline ]"
          onClick={() => dispatch(clearAllFilters())}
        >
          {translate('filter-bar.clear-all')}
        </span>
      )}
    </div>
  );
};

const ActiveFilterChip = ({ filterGroup }) => {
  const dispatch = useDispatch();
  const { selectedOptions, id, label, asSlider } = filterGroup;
  const chipText = useMemo(
    () =>
      asSlider
        ? `${selectedOptions[1]} - ${selectedOptions[0]}`
        : selectedOptions.join(', '),
    [selectedOptions, asSlider]
  );
  if (selectedOptions.length == 0) return null;

  return (
    <div
      className="active-filter-item"
      onClick={() => dispatch(clearFilterGroup(id))}
    >
      <strong style={{ marginRight: '0.25rem' }} className="text-uppercase">
        {label}:
      </strong>{' '}
      {chipText} <X size={10} weight="fill" />
    </div>
  );
};

export default ActiveFilterBar;
